import React, { useEffect, useState } from 'react';
import './EmployeeResignation.css';
import { resginationCheckEmployePersonal } from '../../../services/resignationService';
import { format } from 'date-fns';

const EmployeeResignation = () => {
    const [employeeStatus, setEmployeeSatus] = useState([]);
    const [loading, setLoading] = useState(true);

    const empId = localStorage.getItem("employeeUniqueIdLogin");

    const checkEmployeeResignation = async (empId) => {
        try {
            setLoading(true);
            const response = await resginationCheckEmployePersonal(empId);
            console.log("API Response:", response);

            // Check the actual structure of your response
            console.log("Response data structure:", response);
            console.log("Is response an array?", Array.isArray(response));
            console.log("Response type:", typeof response);

            // Handle the response based on its actual structure
            if (response) {
                // If response is an array, use it directly
                if (Array.isArray(response)) {
                    setEmployeeSatus(response);
                }
                // If response has a data property that contains the array/object
                else if (response.data) {
                    if (Array.isArray(response.data)) {
                        setEmployeeSatus(response.data);
                    } else {
                        // If response.data is a single object, wrap it in an array
                        setEmployeeSatus([response.data]);
                    }
                }
                // If response is a single object, wrap it in an array
                else if (typeof response === 'object' && response !== null) {
                    // Check if the object has employeeId (your data structure)
                    if (response.employeeId) {
                        setEmployeeSatus([response]);
                    } else {
                        setEmployeeSatus([]);
                    }
                }
                else {
                    setEmployeeSatus([]);
                }
            } else {
                setEmployeeSatus([]);
            }
        } catch (error) {
            console.error("Error fetching employee data:", error);
            setEmployeeSatus([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (empId) {
            checkEmployeeResignation(empId);
        }
    }, [empId]);

    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <div>
            <div className='resign-emp-det'>
                <h4 className='header-name-res'>Resign Employee Status</h4>

                <div className='resign-emp-det-table'>
                    <table className='table-resign-emp'>
                        <thead>
                            <tr className='resign-emp-det-tr'>
                                <th>S.No</th>
                                <th>Employee Name</th>
                                {/* <th>Employee ID</th> */}
                                <th>Designation</th>
                                {/* <th>Contact Number</th> */}
                                <th>Client</th>
                                <th>Project</th>
                                <th>Resign Date</th>
                                <th>Notice Period Date</th>
                                <th>Resign Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                employeeStatus.length > 0 ? (
                                    employeeStatus.map((emp, index) => (
                                        <tr key={emp.id || index} className='resign-emp-det-tr'>
                                            <td>{index + 1}</td>
                                            <td>{emp.employeeName}</td>
                                            {/* <td>{emp.employeeId}</td>*/}
                                            <td>{emp.designation}</td>
                                            {/* <td>{emp.contactNumber}</td> */}
                                            <td>{emp.client}</td>
                                            <td>{emp.project}</td>
                                            <td>{format(emp.lastDate,'dd-MM-yyyy')}</td>
                                            <td>{format(emp.noticePeriodDate,'dd-MM-yyyy')}</td>
                                            <td>{emp.resignationStatus}</td>

                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="9" className='header-name-res' >No data available</td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default EmployeeResignation;